<template>
  <div class="main-wrap">
    <!-- 金额总览区域 start -->
    <div class="header-info">
      <div class="title-primary">
        <div class="table">本月租赁额</div>
        <div class="money">￥{{ leaseData.thismouthtotal }}</div>
      </div>
      <van-row class="title-secondary" type="flex" justify="space-between">
        <div>
          <div class="money">￥{{ leaseData.thismounthsubsist }}</div>
          <div class="table">本月应收账款总额</div>
          <br />
          <div class="money">￥{{ leaseData.thismonthamout }}</div>
          <div class="table">本月毛利润</div>
        </div>
        <div>
          <div class="money">￥{{ leaseData.totalsubsist }}</div>
          <div class="table">总应收账款</div>
          <br />
          <div class="money">￥{{ leaseData.todayamout }}</div>
          <div class="table">今日租赁总额</div>
        </div>
      </van-row>

      <!-- <van-row class="echart-wrpa">
        <van-row class="echart-container" :style="{ height: showEchart ? '420px' : '0' }">
          <div class="echart" id="echart01" ref="echart01"></div>
          <div class="echart" id="echart02" ref="echart02"></div>
        </van-row>
        <van-row class="fold" type="flex" justify="center" @click="showEchart = !showEchart">
          <van-icon :class="showEchart ? 'active' : ''" name="arrow-down" />
        </van-row>
      </van-row> -->
    </div>
    <!-- 金额总览区域 end -->

    <!-- 卡片区域 start -->
    <DataReportTableCard :box="box"></DataReportTableCard>
    <!-- 卡片区域 end -->

    <!-- 图表区域 start -->
    <van-row class="echart-container">
      <div class="echart" id="echart01" ref="echart01"></div>
      <div class="echart" id="echart02" ref="echart02"></div>
    </van-row>
    <!-- 图表区域 end -->

    <!-- 列表区域 start -->
    <div class="footer-list">
      <van-list
        class="container list"
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        finished-text="没有更多了"
        error-text="点击重新加载"
        @load="onLoad"
      >
        <!-- 折叠列表区域 start -->
        <van-collapse class="collapseWrap" title-class="title-order" v-model="activeNames">
          <van-collapse-item
            class="item-wrap"
            :title="'订单号:' + item.code"
            :value="item.status"
            value-class="item-value-class"
            :name="item.orderId"
            v-for="item in dataList"
            :key="item.orderId"
          >
            <van-row class="text">订单状态: {{ item.status }}</van-row>
            <van-row class="text">订单金额: {{ item.amount }}</van-row>
            <van-row class="text">本月代付款金额: {{ item.thismouthtopayamount }}</van-row>
            <van-row class="text">
              <van-row>附件:</van-row>
              <van-row type="flex" gutter="20">
                <van-col span="8" v-for="(item, index) in item.file" :key="index">
                  <a :href="item">
                    <van-image
                      width="100"
                      height="100"
                      fit="contain"
                      :src="imgUrl + '/admin/ajax/icon?suffix=' + formatSuffix(item)"
                    />
                  </a>
                </van-col>
              </van-row>
            </van-row>
          </van-collapse-item>
        </van-collapse>
      </van-list>
    </div>
    <!-- 列表区域 end -->
  </div>
</template>

<script>
import { BASE_URL } from "../../../../config/global.js";
import DataReportTableCard from "../../../../components/DataReportTableCard.vue";
import echarts from "echarts";
export default {
  components: {
    DataReportTableCard,
  },
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      page: 1,
      leaseData: {},
      dataList: [],
      box: {},
      activeNames: [],
      orderList: [],
      imgUrl: BASE_URL,
    };
  },
  methods: {
    /**
     * 初始化采购金额信息
     */
    async initMoneyInfo() {
      // 在这发起请求
      let params = {
        id: this.$route.params.id,
      };
      let { data } = await this.$post(this.$api.stGetLeaseMemberInfo, params);
      this.leaseData = data;
      this.box = data.box;
      this.echartInit();
    },
    /**
     * 渲染echart
     */
    echartInit() {
      this.$nextTick(() => {
        const list1 = this.leaseData.mouth.lists;
        const list2 = this.leaseData.year.lists;
        const echart01 = echarts.init(this.$refs.echart01);
        const echart02 = echarts.init(this.$refs.echart02);

        echart01.setOption({
          title: {
            text: this.leaseData.mouth.text || "本月租赁统计",
            left: "center",
            top: "0px",
            textStyle: {
              color: "#505050",
              fontSize: "14px",
            },
          },
          tooltip: { trigger: "axis" },
          color: ["#00baad", "#3c8ff7"],
          legend: {
            orient: "horizontal",
            left: "center",
            bottom: "5px",
            data: ["订单量", "租赁金额(CNY)"],
          },
          grid: {
            left: "20px",
            right: "20px",
            top: "30px",
            bottom: "45px",
            containcolor_3: true,
          },
          // toolbox: { feature: { saveAsImage: {} } },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: list1.dates,
          },
          yAxis: [
            {
              type: "value",
              axisLabel: {
                formatter: function() {
                  return "";
                },
              },
            },
            {
              type: "value",
              axisLabel: {
                formatter: function() {
                  return "";
                },
              },
            },
          ],
          series: [
            {
              name: "订单量",
              type: "line",
              data: list1.num,
              yAxisIndex: 0,
              smooth: true,
            },
            {
              name: "租赁金额(CNY)",
              type: "line",
              data: list1.price,
              yAxisIndex: 0,
              smooth: true,
            },
          ],
        });

        echart02.setOption({
          title: {
            text: this.leaseData.year.text || "本年租赁统计",
            left: "center",
            top: "0px",
            textStyle: {
              color: "#505050",
              fontSize: "14px",
            },
          },
          tooltip: { trigger: "axis" },
          color: ["#00baad", "#3c8ff7"],
          legend: {
            orient: "horizontal",
            left: "center",
            bottom: "5px",
            data: ["订单量", "租赁金额(CNY)"],
          },
          grid: {
            left: "20px",
            right: "20px",
            top: "30px",
            bottom: "45px",
            containcolor_3: true,
          },
          // toolbox: { feature: { saveAsImage: {} } },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: list2.dates,
          },
          yAxis: [
            {
              type: "value",
              axisLabel: {
                formatter: function() {
                  return "";
                },
              },
            },
          ],
          series: [
            {
              name: "订单量",
              type: "bar",
              data: list2.num,
              yAxisIndex: 0,
              smooth: true,
            },
            {
              name: "租赁金额(CNY)",
              type: "bar",
              data: list2.price,
              yAxisIndex: 0,
              smooth: true,
            },
          ],
        });
      });
    },
    /**
     * 列表触底时触发
     */
    async onLoad() {
      // console.log("onLoad");
      // 请求列表数据
      let params = {
        page: this.page,
        id: this.$route.params.id,
      };
      try {
        let { data } = await this.$post(this.$api.stGetLeaseMemberOrderList, params);
        // 若数据已全部加载完毕
        if (data.length == 0) {
          this.finished = true;
        }
        if (this.page == 1) {
          this.dataList = [];
        }
        this.dataList.push(...data);
        this.page++;
      } catch (error) {
        console.log(error);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    formatSuffix(url) {
      let arr = url.split("/");
      let filename = arr[arr.length - 1];
      arr = filename.split(".");
      let suffix = arr[arr.length - 1];
      return suffix;
    },
  },
  mounted() {
    this.initMoneyInfo();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: this.$route.params.name });
    });
  },
};
</script>

<style lang="scss" scoped>
$yellow: #ff8d1a;
$gary: #a6a6a6;
.main-wrap {
  min-height: 100%;
  background-color: #f6f4f2;
  .header-info {
    position: relative;
    box-sizing: border-box;
    padding: 16px;
    font-size: 12px;
    color: #fff;
    background-color: #51596e;

    .title-primary {
      color: #fff;

      .money {
        text-align: center;
        font-family: "MicrosoftJhengHei";
        font-size: 30px;
        font-weight: 500;
      }
    }

    .title-secondary {
      margin-top: 30px;
      text-align: center;
      font-size: 12px;

      .money {
        margin-bottom: 6px;
        color: $yellow;
      }
    }
  }

  .echart-container {
    overflow: hidden;
    .echart {
      margin: 10px 0;
      height: 200px;
      background-color: #fff;
    }
  }
  .footer-list {
    margin-top: 20px;
    padding: 0 12px;
    .container {
      .collapseWrap {
        .item-wrap {
          margin: 16px 0;

          .text {
            line-height: 2;
            font-size: 12px;
            color: #505050;
          }
        }
        ::v-deep.van-cell__title {
          flex: 1;
          font-size: 12px;
          color: #505050;
        }
        ::v-deep.van-cell__value {
          flex: none !important;
        }
      }
    }
  }
}
</style>
